module.exports = window["MaterialUI"].ExpansionPanel;